import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { fetchBanners } from "../../features/bannerSlice";
import { Link } from "react-router-dom";

function Banner() {
  const dispatch = useDispatch();
  const { banners, status, error } = useSelector((state) => state.banner);

  const [loadedImages, setLoadedImages] = useState({});
  const [firstImageLoaded, setFirstImageLoaded] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    fade: true,
    lazyLoad: false,
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchBanners());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (firstImageLoaded && banners.length > 0) {
      banners.forEach((banner, index) => {
        if (index > 0) {
          const img = new Image();
          img.src = banner.banner_img;
          img.onload = () => setLoadedImages((prev) => ({ ...prev, [index]: true }));
        }
      });
    }
  }, [firstImageLoaded, banners]);

  const handleImageLoad = (index) => {
    if (index === 0) {
      setFirstImageLoaded(true);
    }
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  const fetchLinks = (item) => {
    if (item.product_id) {
      return `/product-details/${item.product_slug}`;
    } else if (item.subchildcategory_slug && item.subcategory_slug && item.category_slug) {
      return `/${item.category_slug}/${item.subcategory_slug}/${item.subchildcategory_slug}`;
    } else if (item.subcategory_slug && item.category_slug) {
      return `/${item.category_slug}/${item.subcategory_slug}`;
    } else if (item.category_slug) {
      return `/${item.category_slug}`;
    } else if (item.classification_slug) {
      return `/classification_list/${item.classification_slug}`;
    }
  };

  return (
    <div className="banner_section_main">
      <Slider {...settings}>
        {banners.length > 0 &&
          banners.map((item, index) => (
            <div key={index} className="banner-slide">
              <Link to={fetchLinks(item)}>
                <div className="banner-image-container">
                  {!loadedImages[index] && <div className="image-placeholder"></div>}
                  <img
                    src={item.banner_img}
                    alt={item.banner_title}
                    className={`carousel-image ${loadedImages[index] ? "loaded" : "loading"}`}
                    onLoad={() => handleImageLoad(index)}
                  />
                </div>
              </Link>
            </div>
          ))}
      </Slider>
    </div>
  );
}

export default Banner;
